export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="bg-gradient-to-br from-secondary-50 to-background-50 rounded-2xl border border-secondary-200/60 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="flex items-center justify-center lg:justify-start gap-3 mb-4">
                <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">联系我们</h2>
              </div>

              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                如果您有网红爆料线索、商务合作需求或内容投诉建议，欢迎通过以下方式与我们取得联系。我们将在24小时内回复您的来信。
              </p>

              <div className="space-y-3 mb-6">
                <div className="flex items-center justify-center lg:justify-start gap-3 text-sm text-foreground-600">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                  <span>投稿邮箱：tips@wanghongbaoliao.com</span>
                </div>
                <div className="flex items-center justify-center lg:justify-start gap-3 text-sm text-foreground-600">
                  <i className="ri-customer-service-line text-primary-500 text-lg"></i>
                  <span>商务合作：business@wanghongbaoliao.com</span>
                </div>
                <div className="flex items-center justify-center lg:justify-start gap-3 text-sm text-foreground-600">
                  <i className="ri-alert-line text-primary-500 text-lg"></i>
                  <span>内容投诉：report@wanghongbaoliao.com</span>
                </div>
              </div>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <button
                  type="button"
                  className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-md transition-all cursor-pointer whitespace-nowrap"
                >
                  提交爆料线索
                </button>
                <button
                  type="button"
                  className="px-5 py-2.5 bg-background-50 hover:bg-secondary-100 text-foreground-700 font-medium text-sm rounded-md border border-secondary-300 transition-all cursor-pointer whitespace-nowrap"
                >
                  商务合作咨询
                </button>
              </div>
            </div>

            <div className="flex-1 w-full max-w-sm">
              <div className="relative w-full h-48 md:h-56 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20modern%20office%20contact%20center%20with%20soft%20amber%20and%20crimson%20ambient%20lighting%2C%20professional%20workspace%2C%20clean%20aesthetic%2C%20editorial%20photography%20style%2C%20warm%20tones%2C%20elegant%20dark%20background%20with%20warm%20highlights%2C%20cinematic%20mood&width=600&height=450&seq=contact-section&orientation=landscape"
                  alt="网红爆料联系我们"
                  className="w-full h-full object-cover object-top"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.classList.add('hidden');
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}